var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__1MPPaJ5__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M22.68,0H1.32A1.32,1.32,0,0,0,0,1.32V22.68A1.32,1.32,0,0,0,1.32,24h11.5V14.71H9.69V11.09h3.13V8.41c0-3.1,1.89-4.79,4.66-4.79a23.5,23.5,0,0,1,2.79.15V7H18.35c-1.5,0-1.79.72-1.79,1.77v2.31h3.58l-.46,3.63H16.56V24h6.11A1.32,1.32,0,0,0,24,22.68V1.32A1.32,1.32,0,0,0,22.68,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.59227dfa6ae9d9a7e6dba0d5770a3522.svg";
export { ForwardRef as ReactComponent };